import React, { useState } from 'react';
import Sym from '../components/Sym';
import SectionHead from '../components/SectionHead';

/**
 * Dudas frecuentes. Copy del diseño, con dos respuestas AJUSTADAS a las
 * decisiones de negocio (23-jul):
 *  - Prueba CON tarjeta al inicio (no "sin tarjeta").
 *  - Seguridad: sin ISO/IEC 27001; México suavizado ("conforme a la ley mexicana");
 *    presumimos lo verificado (AES-256, respaldos diarios, acceso por rol).
 *  - Enterprise: sin "API privada".
 */
const FAQS = [
  {
    q: '¿Cómo funciona la prueba de 15 días?',
    a: 'Te das de alta y usas PaySlip completo durante 15 días. Capturas tu tarjeta al iniciar, pero no se te cobra durante la prueba; si cancelas antes de que termine, no pagas nada.',
  },
  {
    q: '¿PaySlip calcula o timbra mi nómina?',
    a: 'No. PaySlip no calcula ni timbra: descarga del SAT los recibos que ya timbraste —con tu e.firma— y los pone al alcance de administradores y colaboradores.',
  },
  {
    q: '¿Qué necesito para empezar?',
    a: 'El RFC de tu empresa y tu e.firma (FIEL) vigente. Con eso PaySlip se conecta al SAT y baja tus recibos.',
  },
  {
    q: '¿Puedo cancelar cuando quiera?',
    a: 'Cuando quieras. No hay plazos forzosos ni penalizaciones: pagas mes con mes.',
  },
  {
    q: '¿Están seguros mis datos y mi e.firma?',
    a: 'Sí. Ciframos tu e.firma con AES-256, hacemos respaldos diarios y cada colaborador ve únicamente sus propios recibos (acceso por rol). El tratamiento de tus datos y tu aviso de privacidad son conforme a la ley mexicana.',
  },
  {
    q: '¿Sirve para más de 5,000 colaboradores o despachos?',
    a: 'Claro. Armamos un plan a la medida con SLA dedicado y un contacto asignado. Escríbenos y lo vemos.',
  },
];

const Item = ({ q, a, open, onToggle }) => (
  <div style={{ border: '1px solid var(--border)', borderRadius: 16, background: 'var(--surface)', overflow: 'hidden' }}>
    <button
      type="button"
      onClick={onToggle}
      style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, padding: '20px 22px', background: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}
    >
      <span style={{ font: "600 1.08rem 'Hanken Grotesk'", color: 'var(--heading)' }}>{q}</span>
      <Sym name={open ? 'remove' : 'add'} size={22} color="#6FA0FF" />
    </button>
    {open && (
      <p style={{ font: "400 1.02rem/1.6 'Hanken Grotesk'", color: 'var(--muted)', margin: 0, padding: '0 22px 22px' }}>{a}</p>
    )}
  </div>
);

const FAQ2 = () => {
  const [open, setOpen] = useState(0);
  return (
    <section style={{ maxWidth: 820, margin: '0 auto', padding: '48px clamp(20px,5vw,40px)' }}>
      <SectionHead eyebrow="Dudas frecuentes" title="Antes de que" accent="preguntes" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 36 }}>
        {FAQS.map((f, i) => (
          <Item key={f.q} {...f} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
        ))}
      </div>
    </section>
  );
};

export default FAQ2;
